import {isNativeWebView} from './isNativeWebView';
import {updateWidget} from './updateWidget';
import {sendMessage} from './sendMessage';
import {onlyNative} from './onlyNative';

export const androidDevice: DeviceService = {
  sendMessage: onlyNative(sendMessage),
  updateWidget: onlyNative(updateWidget),
  canInstallApp: (): boolean => false,
  isNative: isNativeWebView,
};
